<button
  *ngIf="canEdit"
  [ngClass]="{ 'floatFab': !isRtl, 'floatFabRtl': isRtl }"
  mat-fab
  color="primary"
  (click)="editMode = !editMode"
>
  <mat-icon>{{ editMode ? 'edit' : 'done' }}</mat-icon>
</button>
<table mat-table [dataSource]="displayedUsers">
  <ng-container matColumnDef="selected">
    <th
      mat-header-cell
      style="width: 15px"
      *matHeaderCellDef
      i18n
      [fxHide]="!editMode"
    >
      Select
    </th>
    <td
      mat-cell
      [fxHide]="!editMode"
      style="width: 15px"
      *matCellDef="let user"
      [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
    >
      <mat-checkbox
        [checked]="isSelected(user)"
        (change)="applySelectionChange(user.id, $event.checked)"
      ></mat-checkbox>
    </td>
  </ng-container>

  <ng-container matColumnDef="icon">
    <th mat-header-cell style="width: 15px" *matHeaderCellDef></th>
    <td
      mat-cell
      style="width: 15px"
      *matCellDef="let user"
      [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
    >
      <mat-icon
        svgIcon="account"
        [color]="user === highlightedUser ? 'primary' : ''"
      ></mat-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="userName">
    <th
      mat-header-cell
      *matHeaderCellDef
      [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
      i18n
    >
      User Name
    </th>
    <td
      mat-cell
      *matCellDef="let user"
      [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
    >
      <span>{{ user.username }} </span>
      <div fxHide.gt-sm>{{ user.firstName }} {{ user.lastName }}</div>
    </td>
  </ng-container>

  <ng-container matColumnDef="fullName">
    <th
      mat-header-cell
      fxHide.lt-md
      *matHeaderCellDef
      [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
      i18n
    >
      Full Name
    </th>
    <td
      mat-cell
      *matCellDef="let user"
      fxHide.lt-md
      [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
    >
      {{ user.firstName }} {{ user.lastName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="email">
    <th
      mat-header-cell
      fxHide.lt-md
      *matHeaderCellDef
      [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
      i18n
    >
      E-Mail
    </th>
    <td
      mat-cell
      fxHide.lt-md
      *matCellDef="let user"
      [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
    >
      {{ user.email }}
    </td>
  </ng-container>

  <!-- Symbol Column -->
  <ng-container matColumnDef="phoneNumber">
    <th
      mat-header-cell
      fxHide.lt-md
      *matHeaderCellDef
      [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
      i18n
    >
      Phone Number
    </th>
    <td
      mat-cell
      fxHide.lt-md
      *matCellDef="let user"
      [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
    >
      {{ user.phoneNumber }}
    </td>
  </ng-container>

  <tr
    mat-header-row
    fxHide.lt-md
    *matHeaderRowDef="
      ['icon', 'userName', 'fullName', 'email', 'phoneNumber'];
      sticky: true
    "
  ></tr>
  <tr
    mat-row
    class="highlightRow"
    *matRowDef="
      let row;
      columns: ['icon', 'userName', 'fullName', 'email', 'phoneNumber']
    "
    (mouseenter)="highlightedUser = row"
    (mouseleave)="highlightedUser = null"
  ></tr>
</table>
